import { supabase } from 'utils/supabaseClient';
import { useAuth } from 'contexts/AuthContext';

export function useLogout() {
    const { resetAuth } = useAuth();
  
    const handleLogout = async () => {
        const { error } = await supabase.auth.signOut();
        if (error) {
            console.error('Logout error:', error.message);
            // Clear Supabase session from storage so refresh doesn't restore a broken session (e.g. after 403)
            localStorage.removeItem('sb-awnvrpeqgojsamnbydix-auth-token');
        }
        // Always clear app state and redirect, even if server returned 403 (session already invalid)
        resetAuth();
        window.location.href = '/loginsignup';
    };

    return handleLogout;

};

